import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import './LangFlagSelect.css';

/**
 * Select de langue avec image de drapeau.
 * options : liste de codes/valeurs ; meta(value) -> { name, flagUrl, emoji }
 * (flagUrl vient du catalogue DB, sinon flagcdn, sinon emoji en repli)
 */
export default function LangFlagSelect({ value, onChange, options, meta, placeholder, ariaLabel }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const renderFlag = (m) => (m.flagUrl
    ? <img className="lang-flag-img" src={m.flagUrl} alt="" loading="lazy" />
    : <span className="lang-flag-emoji" aria-hidden="true">{m.emoji || '🌐'}</span>);

  const current = value ? meta(value) : null;

  return (
    <div className={'lang-flag-select' + (open ? ' is-open' : '')} ref={ref}>
      <button
        type="button"
        className="lang-flag-select-btn"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={ariaLabel}
      >
        {current ? (
          <>
            {renderFlag(current)}
            <span className="lang-flag-name">{current.name}</span>
          </>
        ) : (
          <span className="lang-flag-placeholder">{placeholder}</span>
        )}
        <ChevronDown size={14} className="lang-flag-caret" aria-hidden="true" />
      </button>
      {open && (
        <ul className="lang-flag-list" role="listbox" aria-label={ariaLabel}>
          {options.map((code) => {
            const m = meta(code);
            return (
              <li key={code}>
                <button
                  type="button"
                  role="option"
                  aria-selected={code === value}
                  className={'lang-flag-option' + (code === value ? ' is-selected' : '')}
                  onClick={() => { onChange(code); setOpen(false); }}
                >
                  {renderFlag(m)}
                  <span className="lang-flag-name">{m.name}</span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
